import { Box, Typography } from "@mui/material";
import { getMenuIcon } from "../../config/menus.tsx";

interface PagePlaceholderProps {
  menu: { menu_name: string; icon?: string };
}

export default function PagePlaceholder({ menu }: PagePlaceholderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        gap: 1.5,
        color: "#94a3b8",
      }}
    >
      <Box sx={{ fontSize: 56, color: "#94a3b8" }}>{getMenuIcon(menu.icon)}</Box>
      <Typography variant="h4">{menu.menu_name}</Typography>
      <Typography variant="body2">This module is under construction.</Typography>
    </Box>
  );
}